module.exports = __webpack_public_path__ + "static/media/amn-auditor.af4d8282.svg";